export const getInitial = (newId, selected, ticketOwners, whoami, commit) => {
  const getSelectedPerson = () => {
    if (whoami.isAuthenticated) {
      return {
        firstName: whoami.firstname || "",
        lastName: whoami.lastname || "",
        email: whoami.email || "",
        civicRegistrationNumber: whoami.civicRegistrationNumber || "",
      };
    }
    if (commit && ticketOwners && ticketOwners?.length === 0) {
      return {
        firstName: commit.firstname || "",
        lastName: commit.lastname || "",
        email: commit.email || "",
        civicRegistrationNumber: commit.civicRegistrationNumber || "",
      };
    }
    if (ticketOwners && selected) {
      let selectedPerson = ticketOwners.find((o) => o.id === selected);
      if (!selectedPerson) {
        return {};
      }
      return selectedPerson;
    }
    return {};
  };
  const person = getSelectedPerson();
  let initial = {
    id: person.id || newId,
    firstName: person.firstName || "",
    lastName: person.lastName || "",
    email: person.email || "",
    civicRegistrationNumber: person.civicRegistrationNumber || "",
    cellPhone: person.cellPhone || "",
    street: "",
    streetNumber: "",
    zipCode: "",
    city: "",
    countryCode: "",
  };

  return initial;
};

const addressFields = [
  "street",
  "streetNumber",
  "zipCode",
  "city",
  "countryCode",
];

export const getVisible = (visibleFields, field, deliveryMethod) => {
  if (visibleFields.includes(field)) return true;
  if (
    deliveryMethod &&
    deliveryMethod.mandatoryAddress &&
    addressFields.includes(field)
  )
    return true;
  return false;
};

export const getRequired = (requiredFields, field, deliveryMethod) => {
  if (requiredFields.includes(field)) return true;
  if (
    deliveryMethod &&
    deliveryMethod.mandatoryAddress &&
    addressFields.includes(field)
  )
    return true;
  return false;
};

export const getInitialTouched = (values) => {
  let nonEmpty = {};
  const fields = Object.keys(values);
  fields.forEach((f) => {
    if (values[f].length > 0) {
      nonEmpty = { ...nonEmpty, [f]: true };
    }
  });
  return nonEmpty;
};
